import _ from 'lodash';
import {validateShortDescription} from './Validations';

export default class ShortDescripList {
  constructor(file) {
    this.file = file;
  }

  fileContent() {
    return new Promise((resolve, reject) => {
      if(this._fileContent) {
        resolve(this._fileContent);
      } else {
        let reader = new FileReader();
        reader.onload = () => {
          this._fileContent = reader.result;
          resolve(this._fileContent);
        };
        reader.readAsText(this.file);
      }
    });
  }

  lines() {
    return new Promise((resolve, reject) => {
      if(this._lines) {
        resolve(this._lines);
      } else {
        this.fileContent().then((content) => {
          this._lines = this.sanitizeLineContent(content);
          resolve(this._lines);
        });
      }
    });
  }

  indexedLines() {
    return new Promise((resolve, reject) => {
      if(this._indexedLines) {
        resolve(this._indexedLines);
      } else {
        this.lines().then((lines) => {
          this._indexedLines = this.sortedLines(lines);
          resolve(this._indexedLines);
        });
      }
    });
  }

  errorLines() {
    return new Promise((resolve, reject) => {
      if(this._errorLines) {
        resolve(this._errorLines);
      } else {
        this.indexedLines().then((lines) => {
          resolve(this._errorLines);
        });
      }
    });
  }

  shortDescrip(name) {
    return new Promise((resolve, reject) => {
      this.indexedLines().then((indexedLines) => {
        resolve(indexedLines[name]);
      });
    });
  }

  sortedLines(lines) {
    let sorted = {};
    this._errorLines = [];
    lines.map((line, ind) => {
      let matches = line.match(/([^\t]+)\t(.+)/);
      if(matches && validateShortDescription(matches[2])) {
        sorted[matches[1]] = matches[2];
      } else {
        this._errorLines.push(line);
      }
    });
    return sorted;
  }

  sanitizeLineContent(string) {
    return _(string.split(/\r?\n/))
      .map((str) => {
        return str.trim();
      })
      .filter((str) => {
        return str !== '';
      })
      .value();
  }
}
